module.exports = __webpack_public_path__ + "static/media/farmers.a5901067.webp";